/**
 * Returns a sanitized href string, or null if the URL is unsafe or empty.
 *
 * Parsing is delegated to the WHATWG URL parser so scheme-obfuscation tricks
 * (leading whitespace, tabs, mixed case, percent-encoding) are normalized
 * before the protocol is checked against an allowlist. Only http/https/mailto
 * are permitted; javascript:, data:, vbscript:, etc. return null. Relative
 * URLs are resolved against the current origin.
 *
 * @param {string} url
 * @returns {string|null}
 */
export function safeHref(url) {
  if (url == null || typeof url !== 'string' || !url.trim()) {
    return null;
  }

  try {
    const parsed = new URL(url, window.location.origin);
    if (!['http:', 'https:', 'mailto:'].includes(parsed.protocol)) {
      return null;
    }
    return parsed.toString();
  } catch {
    return null;
  }
}
